module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "full-width": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialogLembreteSenha),
      callback: function($$v) {
        _vm.dialogLembreteSenha = $$v
      },
      expression: "dialogLembreteSenha"
    }
  }, [_c('div', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n     Não consegue acessar sua conta?\n   ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Esqueci minha senha")])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "name": "form-login",
      "value": "true"
    },
    model: {
      value: (_vm.formValido),
      callback: function($$v) {
        _vm.formValido = $$v
      },
      expression: "formValido"
    }
  }, [_c('v-card-text', [_vm._v("\n        Preencha o campo abaixo com seu e-mail\n        "), _c('v-text-field', {
    attrs: {
      "name": "Email",
      "label": "E-mail",
      "rules": _vm.emailRegras,
      "prepend-icon": "mail_outline",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogLembreteSenha = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.enviarSenha
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n        Enviar\n        "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74280109","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/LembreteSenha.vue
// module id = 443
// module chunks = 7 11 16